import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type ExtendedBuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { menuItemReference } from '@nodeTypeConfig/helpers/editComponents/menuItemReference';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { extendsSection } from '../../helpers/genericConfigHelpers';
import { asideWebTypeNotRequired } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
// Extends SECTION => A SECTION inside the PRO_HOME_AGE becomes a PRO_MENU_SECTION
const PRO_MENU_SECTION: ExtendedBuildingBlockNodeConfig = {
  nodeSelector: selectTitleNode,
  information: {
    single: 'Menu Item',
    plural: 'Menu Items',
    ribonIcon: require('../../../../../img/buildingBlocks/SECTION.svg'),
  },
  ...extendsSection,
  isCollapsedByDefault: false,
  buildingBlocks: [{ type: NodeType.SECTION }],
  edit: [titleComponent, menuItemReference],
  webTab: [asideWebTypeNotRequired],
};

export default PRO_MENU_SECTION;
